import { render, staticRenderFns } from "./Storeinformation.vue?vue&type=template&id=1a03fc44"
import script from "./Storeinformation.vue?vue&type=script&lang=js"
export * from "./Storeinformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports